// This feature has no effect in the frontend
// Will be checked in the backend
import type { Feature } from 'util/stdtypes';

export const ConvoMatchFeature: Feature<{}, {}> = {
    name: 'Content Convo Match',
    key: 'convomatch',
    providesConfig: {},
};
